import {IRental} from "../components/RentalList/RentalInterfaces";

const GetDaysCount = (start: string, end: string): number => {
  const startRentalDate = new Date(start).toLocaleDateString('ru-RU').toString();
  let endRentalDate = new Date(Date.now()).toLocaleDateString('ru-RU').toString();
  if (end) {
    endRentalDate = new Date(end).toLocaleDateString('ru-RU').toString();
  }
  // console.log("startRentalDate: ", startRentalDate, "endRentalDate: ", endRentalDate, "end: ", end);

  const [startDay, startMonth, startYear] = startRentalDate.split('.').map(Number);
  const [endDay, endMonth, endYear] = endRentalDate.split('.').map(Number);
  const startDate = new Date(startYear, startMonth - 1, startDay);
  const endDate = new Date(endYear, endMonth - 1, endDay);
  const diffInMs = endDate.getTime() - startDate.getTime();
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  return diffInDays;
};

export function normalizePhoneNumber(input: string): string {
  const digitsOnly = input.replace(/\D/g, '');

  if (digitsOnly === '') return '';

  if (digitsOnly.length === 10 && digitsOnly.startsWith('0')) {
    return `+38${digitsOnly}`;
  }

  if (digitsOnly.length === 11 && digitsOnly.startsWith('8')) {
    return `+3${digitsOnly}`;
  }

  if (digitsOnly.length === 12 && digitsOnly.startsWith('38')) {
    return `+${digitsOnly}`;
  }

  if (digitsOnly.length === 12 && digitsOnly.startsWith('380')) {
    return `+${digitsOnly}`;
  }

  if (input.startsWith('+38') && digitsOnly.length === 12) {
    return `+${digitsOnly}`;
  }

  return `+${digitsOnly}`;
}

export function ExtraProducts(rental: IRental): string {
  // console.log("ExtraProducts: ", rental.extras);
  if (!rental.extras || rental.extras.length === 0) {return ""}
  let extraProducts: string = "";
  rental.extras.forEach((product) => {
    // console.log(product)
    extraProducts += `${product.name}, \r\n`;
  })
  return extraProducts;
}

export function ExtraProductsCost(rental: IRental): number {
  // console.log("ExtraProductsCost: ", rental.extras);
  if (!rental.extras || rental.extras.length === 0) return 0
  let extraProducts: number = 0;
  rental.extras.forEach((product) => {
    // console.log(product)
    if (Number(product.extra_price) === 0) {
      extraProducts += Number(product.price);
    } else {
      extraProducts += (Number(product.extra_price) * GetDaysCount(rental.start_date, rental.end_date));
    }
  })
  // console.log("ExtraProductsCost price: ", extraProducts);
  return extraProducts;
}

export const getDeliveryPrice = (rental: IRental | null) => {
  if (!rental) {return {sum: 0, price: 0, rentPrice: 0}}
  let extraPrice: number = 0;
  let deliveryPrice: number = 0;
  let deliveryPriceType: boolean | undefined = true;
  let deliveryExtraPrice: number | undefined = 0;

  if (rental.extras?.length > 0) {
    // console.log("extras: ", rental.extras);
    rental.extras.forEach((item) => {
      // console.log(item);
      if (item.price) {
        extraPrice += Number(item.price);
      }
    })
  }
  // console.log("EXTRA PRICE: ", extraPrice);

  if (rental.deliveries?.length === 1) {
    if (rental.deliveries[0].price) {
      deliveryPrice += Number(rental.deliveries[0].price);
    }
    deliveryPriceType = rental.deliveries[0].is_fixed
    deliveryExtraPrice = rental.deliveries[0].extra_price;
  }
  // console.log("DELIVERYEXTRAPRICE: ", deliveryExtraPrice);

  let mainProductPrice = 0;

  if (Number(rental.deposit) !== 0) {
    mainProductPrice = Number(rental.deposit);
  } else {
    mainProductPrice = Number(rental.price_per_day);
  }

  const rentPrice = mainProductPrice + Number(extraPrice);
  // console.log("RENTPRICE: ", rentPrice);
  const price = rentPrice + Number(deliveryPrice);
  // console.log("PRICE: ", price);
  const deliverySum = deliveryPriceType ? `${price}грн` : `${price} + ${deliveryExtraPrice}грн за км`;
  return {sum: deliverySum, price: price, rentPrice: rentPrice}
};

export const getReturnRental = (rental: IRental | null) => {
  if (!rental) return 0;
  // console.log("------------------")
  // console.log("--- getReturnRental rental: ", rental);
  let deliveryCost = Number(rental.deposit);
  const rentalProductCost =  (Number(rental.price_per_day) * Number(GetDaysCount(rental.start_date, rental.end_date)));
  // console.log("--- getReturnRental rentalProductCost: ", rentalProductCost, Number(rental.price_per_day), Number(GetDaysCount(rental.start_date, rental.end_date)));
  let extraPrice = 0;
  if (rental.extras?.length > 0) {
    rental.extras.forEach((item) => {
      // console.log("--- getReturnRental extra item: ", item);
      if (item.extra_price && Number(item.extra_price) !== 0) {
        extraPrice += (Number(item.extra_price) * Number(GetDaysCount(rental.start_date, rental.end_date)));
        deliveryCost += Number(item.price);
      }
    })
  }
  // console.log("--- getReturnRental extraPrice: ", extraPrice);
  // console.log("--- getReturnRental deliveryCost: ", deliveryCost);
  let returnDeliveryPrice = 0;
  if (rental.deliveries.length === 2) {
    returnDeliveryPrice = rental.deliveries[1].price;
  }
  // console.log("--- getReturnRental: deliveryCost - (rentalProductCost + extraPrice + returnDeliveryPrice)");
  // console.log("--- getReturnRental: ", deliveryCost, "- (",rentalProductCost, "+", extraPrice, "+", returnDeliveryPrice,")");
  return deliveryCost - (rentalProductCost + extraPrice + returnDeliveryPrice);
}

export const calculateDistance = (lat1: number , lon1: number, lat2: number, lon2: number): number => {
  const R = 6371e3; // Earth radius in meters
  const φ1 = (lat1 * Math.PI) / 180;
  const φ2 = (lat2 * Math.PI) / 180;
  const Δφ = ((lat2 - lat1) * Math.PI) / 180;
  const Δλ = ((lon2 - lon1) * Math.PI) / 180;

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
};

export default GetDaysCount;